import { AlarmStatistics, PaginatedAlarmList } from "@/models/alarm/alarm-list.model";
import { format } from "date-fns";
import { AlarmListPaginatedDto, AlarmStatisticsDTO } from "../dtos";

export const mapAlarmListPaginatedDTOtoAlarmListPaginated = (
  data: AlarmListPaginatedDto
): PaginatedAlarmList => {
  return {
    alarms: data.data.alarms.map((alarm) => ({
      _id: alarm._id,
      ownerId: alarm.ownerId,
      type: alarm.type,
      name: alarm.name,
      level: alarm.level,
      createdAt: format(new Date(alarm.createdAt), "yyyy-MM-dd HH:mm"),
      alarmTitle: alarm.alarmTitle,
      monitorId: alarm.monitorId,
      username: alarm.username,
      roomId: alarm.roomId,
      deviceLocation: alarm.deviceLocation,
      calls: alarm.calls,
      sms: alarm.sms,
      emails: alarm.emails,
      push: alarm.push,
    })),
    totalPages: data.data.totalPages,
    totalAlarms: data.data.totalAlarms,
  };
};

export const mapAlarmStatisticsDTOtoAlarmStatistics = (
  data: AlarmStatisticsDTO
): AlarmStatistics => {
  return {
    last7Days: data.data.last7Days,
    last30Days: data.data.last30Days,
    total: data.data.total,
  };
};
